import { useFeatureFlagShallowStore } from '@frontend/shared';

const UI_SUBSCRIPTION_RELEASE_FLAG_ID = 'ui-subscription-release';

export const useIsUISubscriptionReleaseFlagEnabled = () => {
  const { getFlag } = useFeatureFlagShallowStore('getFlag');
  const isSubscriptionReleaseFlagEnabled = getFlag(UI_SUBSCRIPTION_RELEASE_FLAG_ID);
  return isSubscriptionReleaseFlagEnabled;
};
